module.exports = __webpack_public_path__ + "img/ALL_TYPE.c863ac42.jpg";